/* eslint-disable quotes */
/* eslint-disable no-unused-vars */
import axios from "axios";
import { get } from "lodash";

const path = (api, url) => `${api}${url}`;

function processResponse(response) {
  const filename = response.headers["content-disposition"].split('"')[1];
  const file = new Blob([response.data], { type: "application/pdf" });
  file.filename = filename;
  return file;
}

async function fetch(api, url, config) {
  const { headers, method = "GET", ...rest } = config;

  const options = {
    method,
    responseType: "blob",
    headers: {
      ...headers,
    },
    ...rest,
  };

  try {
    return processResponse(await axios(path(api, url), options));
  } catch (e) {
    const status = get(e, "response.status");
    throw e;
  }
}

export default fetch;
